<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Prix moyen</h2>
        </div>
    </div>
    <div class="card-body col-12">
        <img *ngIf="preview" src="assets/widgets/ss_prix_moyen.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">
            <div class="col-6" *ngIf="favorite.ad_city.mapping_quartier_iris && favorite.ad_city.mapping_quartier_iris.quartier">
                <mat-form-field>
                    <mat-label>Secteur</mat-label>
                    <mat-select disableOptionCentering [(ngModel)]="secteur" (ngModelChange)="edit($event, 'secteur')" [disabled]="favorite.ad_city.mapping_quartier_iris == null || favorite.ad_city.mapping_quartier_iris.quartier == null || favorite.ad_city.mapping_quartier_iris.quartier.length == 1">
                        <mat-option value="">Tous les secteurs</mat-option>
                        <ng-container *ngIf="favorite.ad_city.mapping_quartier_iris.quartier.length > 1">
                            <mat-option *ngFor="let group of favorite.ad_city.mapping_quartier_iris.quartier" [value]="group.GQ_c">{{ group.GQ_n }}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-6" *ngIf="favorite.ad_city.mapping_quartier_iris && favorite.ad_city.mapping_quartier_iris.quartier">
                <mat-form-field>
                    <mat-label>Quartier</mat-label>
                    <mat-select disableOptionCentering [(ngModel)]="iris" (ngModelChange)="edit($event)" [disabled]="cityService.getQuartier(favorite.ad_city, secteur).length == 0">
                        <mat-option [value]="secteur">Tous les quartiers</mat-option>
                        <mat-option *ngFor="let group of cityService.getQuartier(favorite.ad_city, secteur)"
                                    [value]="group.IRIS_c">{{ group.IRIS_n }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field>
                    <mat-label>Typologie <i class="fa fa-info-circle"
                                            matTooltip="Si certaines options sont &quot;grisées&quot; et non cliquable, c’est parce qu’il n’y a pas eu suffisamment de ventes à cette localisation et pour le type de bien voulu pour avoir une estimation correcte.
Dans ce cas, nous préférons ne pas donner d'estimation plutôt qu'en donner une qui pourrait ne pas refléter la réalité."></i></mat-label>
                    <mat-select disableOptionCentering [(ngModel)]="advice_price_choice" (ngModelChange)="edit($event)">
                        <mat-optgroup *ngFor="let group of priceChoice | keyvalue: adService.sortGeneralFirst"
                                      [label]="group.key">
                            <mat-option *ngFor="let value of group.value | keyvalue"
                                        [disabled]="value.value == undefined || value.value == 0 || value.value.pM == 0"
                                        [value]="value.key">{{cityService.priceFields[value.key].lib}}</mat-option>
                        </mat-optgroup>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-12">
                <div class="data_moy">
                    <h3 class="text-center">
                        Prix au m²
                        <i class="fa fa-info-circle" matTooltip="Prix au m² moyen  pour {{ cityService.getFullLib(advice_price_choice, favorite.ad_city, iris) }}"></i>
                    </h3>
                    <div class="row justify-content-center">
                        <div class="wrap">
                            <div class="row">
                                <div class="col-6 moy_price">
                                    <label>
                                        Moyen <i class="fa fa-info-circle"
                                                 matTooltip="Estimation basée sur les ventes immobilières enregistrées par les notaires, basée sur la localisation et la typologie du bien. Il s'agit du prix médian : 50% des logements similaires ont un prix plus faible, et 50% ont un prix plus élevé."></i>
                                    </label>
                                    <b class="value">
                                        {{ advice_price == 0 ? '-' : advice_price | number:'1.0-0' }}
                                        <span class="unit">€/m²</span>
                                    </b>
                                </div>
                                <div class="col-6 range_price">
                                    <label>
                                        Bas <i class="fa fa-info-circle"
                                               matTooltip="Estimation basée sur les ventes immobilières enregistrées par les notaires, basée sur la localisation et la typologie du bien. Il s'agit du prix bas : 25% des logements similaires ont un prix plus faible, et 75% ont un prix plus élevé."></i>
                                        :
                                    </label>
                                    <b class="value">
                                        {{ advice_price_L == 0 ? '-' : advice_price_L | number:'1.0-0' }}
                                        <span class="unit">€/m²</span>
                                    </b>
                                    <br/>
                                    <label>
                                        Haut <i class="fa fa-info-circle"
                                                matTooltip="Estimation basée sur les ventes immobilières enregistrées par les notaires, basée sur la localisation et la typologie du bien. Il s'agit du prix haut : 75% des logements similaires ont un prix plus faible, et 25% ont un prix plus élevé."></i>
                                        :
                                    </label>
                                    <b class="value">
                                        {{ advice_price_U == 0 ? '-' : advice_price_U | number:'1.0-0' }}
                                        <span class="unit">€/m²</span>
                                    </b>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 text-center confidence" *ngIf="advice_price_cL > 0">
                        Indice de confiance
                        <i class="fa fa-circle{{ advice_price_cL >= 1 ? ' actif' : ''}}" aria-hidden="true"></i>
                        <i class="fa fa-circle{{ advice_price_cL >= 2 ? ' actif' : ''}}" aria-hidden="true"></i>
                        <i class="fa fa-circle{{ advice_price_cL >= 3 ? ' actif' : ''}}" aria-hidden="true"></i>
                        <i class="fa fa-circle{{ advice_price_cL >= 4 ? ' actif' : ''}}" aria-hidden="true"></i>
                        <i class="fa fa-circle{{ advice_price_cL >= 5 ? ' actif' : ''}}" aria-hidden="true"></i>
                    </div>
                    <p *ngIf="advice_price_cL == 0" class="text-center mt-2 mb-0">
                        Le nombre de ventes dans ce quartier est trop faible pour obtenir un prix/m² moyen significatif
                    </p>
                </div>
            </div>
            <div echarts [options]="options" [merge]="data" class="chart" (chartInit)="onChartInit($event)"></div>
        </div>
    </div>
</div>
